export default function Pixel({color = "#fafafa"}) {
    return (
        <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.408203" y="-0.00146484" width="6.00304" height="6.00304" fill={color}/>
        </svg>

    )
}